module.exports = __webpack_public_path__ + "img/home_business_item5.4837eef5.jpg";